// This is my Login File authConfig

import { UserManager } from 'oidc-client-ts';

const oidcConfig = {
  authority: 'https://pccusersnonprod.ciamlogin.com/pccusersnonprod.onmicrosoft.com/v2.0',
  client_id: '3bcc7467-1214-4009-ba08-773b0d23c138',
  redirect_uri: window.location.origin + '/callback',
  response_type: 'code',
  scope: 'openid profile email',
  post_logout_redirect_uri: window.location.origin,
};

export const userManager = new UserManager(oidcConfig);

export const login = () => {
  userManager.signinRedirect();
};

export const logout = () => {
  userManager.signoutRedirect();
};

export const getUser = async () => {
  return await userManager.getUser();
};